import StatusListManager from '@/pages/Business/pages/LogisticOperator/components/StatusListManager';
import type { IntegrationRequestFormSchema } from '../../../../models/IntegrationRequest';
import type { ShippingStatus } from '@/pages/Business/pages/LogisticOperator/models';
import { Control, Controller } from 'react-hook-form';

interface WebhookStatusesFieldProps {
  control: Control<IntegrationRequestFormSchema>;
  statuses: ShippingStatus[];
  disabled: boolean;
}

const WebhookStatusesField = ({ control, statuses, disabled }: WebhookStatusesFieldProps) => (
  <Controller
    name='webhookStatusIds'
    control={control}
    render={({ field, fieldState }) => (
      <div className='flex flex-col gap-1'>
        <span className='text-sm text-gray-700'>Estados a notificar</span>
        <StatusListManager
          selectedStatusIds={field.value}
          availableStatuses={statuses}
          onAdd={(statusId) => field.onChange([...field.value, statusId])}
          onRemove={(statusId) =>
            field.onChange(field.value.filter((id) => id !== statusId))
          }
          label='Buscar estado a notificar'
          disabled={disabled}
        />
        {fieldState.error?.message && (
          <p className='text-xs text-red-600'>{fieldState.error.message}</p>
        )}
      </div>
    )}
  />
);

export default WebhookStatusesField;
